// `<` is escaped so a value containing "</script>" cannot break out of the tag.
export default function StructuredData({ data }) {
    const json = JSON.stringify(data).replace(/</g, '\\u003c');
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
}
